<template>
  <v-expand-transition appear>
    <div class="overflow-hidden">
      <v-divider class="mb-6 mb-sm-8"></v-divider>
    </div>
  </v-expand-transition>
</template>

<script>

export default {
	name: 'divider-view',

	components: {
	},

	props: {

	},

	data: () => ({
	}),

	mounted() {

	},

	created() {

	},

	computed: {

	},

	watch: {},

	methods: {
	}
};
</script>
